import { SharedUiModule } from "@app/shared/ui";
import { SafeUrlPipe } from "./core/pipes/safe-url.pipe";
import { DatepickerComponent } from "./components/form-fields/datepicker/datepicker.component";
import { RichEditorComponent } from "./components/form-fields/rich-editor/rich-editor.component";
/* ====================================
*            ANGULAR IMPORTS
======================================= */

import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

/* ====================================
*            PRIMENG IMPORTS
======================================= */

import { ConfirmationService } from "primeng/api";

/* ====================================
*            CUSTOM IMPORTS
======================================= */

import { FileUploadComponent } from "./components/file-upload/file-upload.component";
import { FormFactoryCoreComponent } from "./components/form-factory/form-factory-core/form-factory-core.component";
import { FormFactoryComponent } from "./components/form-factory/form-factory.component";
import { TableComponent } from "./components/table/table.component";
import { ButtonComponent } from "./components/button/button.component";
import { ContentLayoutComponent } from "./components/templates/content-layout/content-layout.component";
import { TextareaComponent } from "./components/form-fields/textarea/textarea.component";
import { TabComponent } from "./components/tabs/tab/tab.component";
import { TabsComponent } from "./components/tabs/tabs.component";
import { SkeletonComponent } from "./components/skeleton/skeleton.component";
import { InputPasswordComponent } from "./components/form-fields/input-password/input-password.component";
import { InputComponent } from "./components/form-fields/input/input.component";
import { HelpMessageComponent } from "./components/help-message/help-message.component";
import { FieldErrorsComponent } from "./components/form-fields/field-errors/field-errors.component";
import { DropdownComponent } from "./components/form-fields/dropdown/dropdown.component";
import { ChipsComponent } from "./components/form-fields/chips/chips.component";
import { CheckboxComponent } from "./components/form-fields/checkbox/checkbox.component";
import { BlockUiComponent } from "./components/block-ui/block-ui.component";
import { HeaderComponent } from "./includes/header/header.component";
import { MainLayoutComponent } from "./includes/layout/main-layout/main-layout.component";
import { SidebarComponent } from "./includes/sidebar/sidebar.component";
import { CloseIconComponent } from "./components/close-icon/close-icon.component";

/* ====================================
*           SORTABLEJS IMPORTS
======================================= */

import { HeaderAlertComponent } from "./components/header-alert/header-alert.component";

/* ====================================
*            TINYMCE IMPORTS
======================================= */

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { SimpleLayoutComponent } from "./components/templates/simple-layout/simple-layout.component";
import { MultiSelectComponent } from "./components/form-fields/multi-select/multi-select.component";
import { ColorPickerComponent } from "./components/form-fields/color-picker/color-picker.component";
import { TableFiltersComponent } from "./components/table/table-filters/table-filters.component";
import "hammerjs";
import { ClientLayoutComponent } from "./includes/layout/client-layout/client-layout.component";
import { NavbarComponent } from "./includes/navbar/navbar.component";
import { FooterComponent } from "./includes/footer/footer.component";
import { FileUploadV2Component } from "./components/file-upload-v2/file-upload-v2.component";
import { PublicLayoutComponent } from "./includes/layout/public-layout/public-layout.component";
import { ToggleComponent } from "./components/form-fields/toggle/toggle.component";
import { DropdownMenuComponent } from "./components/dropdown-menu/dropdown-menu.component";
import { GenerateReportComponent } from "./components/generate-report/generate-report.component";
import { InputNumberComponent } from "./components/form-fields/input-number/input-number.component";
import { ImportComponent } from "./components/import/import.component";

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    MainLayoutComponent,
    BlockUiComponent,
    CheckboxComponent,
    ChipsComponent,
    CloseIconComponent,
    DropdownComponent,
    FieldErrorsComponent,
    HelpMessageComponent,
    InputComponent,
    InputPasswordComponent,
    SkeletonComponent,
    TabsComponent,
    TabComponent,
    TextareaComponent,
    ContentLayoutComponent,
    ButtonComponent,
    TableComponent,
    FormFactoryComponent,
    FormFactoryCoreComponent,
    FileUploadComponent,
    HeaderAlertComponent,
    RichEditorComponent,
    SimpleLayoutComponent,
    MultiSelectComponent,
    ColorPickerComponent,
    TableFiltersComponent,
    DatepickerComponent,
    ClientLayoutComponent,
    NavbarComponent,
    FooterComponent,
    FileUploadV2Component,
    SafeUrlPipe,
    PublicLayoutComponent,
    ToggleComponent,
    DropdownMenuComponent,
    GenerateReportComponent,
    InputNumberComponent,
    ImportComponent,
  ],
  imports: [
    CommonModule,
    SharedUiModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
    MainLayoutComponent,
    BlockUiComponent,
    CheckboxComponent,
    ChipsComponent,
    CloseIconComponent,
    DropdownComponent,
    FieldErrorsComponent,
    HelpMessageComponent,
    InputComponent,
    InputPasswordComponent,
    SkeletonComponent,
    TabsComponent,
    TabComponent,
    TextareaComponent,
    ContentLayoutComponent,
    ButtonComponent,
    TableComponent,
    FormFactoryComponent,
    FormFactoryCoreComponent,
    FileUploadComponent,
    HeaderAlertComponent,
    RichEditorComponent,
    SimpleLayoutComponent,
    MultiSelectComponent,
    ColorPickerComponent,
    TableFiltersComponent,
    DatepickerComponent,
    ClientLayoutComponent,
    FileUploadV2Component,
    DropdownMenuComponent,
    GenerateReportComponent,
    ImportComponent,
  ],
  providers: [
    ConfirmationService,
    DialogService,
    DynamicDialogRef,
    DynamicDialogConfig,
    SafeUrlPipe,
  ],
})
export class SharedComponentsModule {}
